import CloseIcon from '@mui/icons-material/Close';
import {
    Dialog,
    DialogContent,
    DialogContentText,
    DialogProps,
    DialogTitle,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    styled
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

const StyledDialog = styled(Dialog)`
    & .MuiDialog-paper {
        width: 800px;
    }

    & .MuiDialogTitle-root {
        display: flex;
        justify-content: flex-end;
    }
` as typeof Dialog;

const RosterModal = (props: DialogProps) => {
    const { t } = useTranslation('invite_students');
    const { onClose, ...other } = props;

    const handleClose = () => {
        onClose?.({}, 'backdropClick');
    };

    return (
        <StyledDialog onClose={handleClose} {...other}>
            <DialogTitle>
                <IconButton onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <DialogContentText>
                    <Trans t={t} i18nKey="upload-invite.instructions.allowed-roles" />
                </DialogContentText>

                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{`first_name`}</TableCell>
                                <TableCell>{`last_name`}</TableCell>
                                <TableCell>{`email`}</TableCell>
                                <TableCell>{`role`}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>{`John`}</TableCell>
                                <TableCell>{`Doe`}</TableCell>
                                <TableCell>{`john_doe@example.com`}</TableCell>
                                <TableCell>{`teacher`}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{`John`}</TableCell>
                                <TableCell>{`Smith`}</TableCell>
                                <TableCell>{`john_smith@example.com`}</TableCell>
                                <TableCell>{`assistant`}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{`Patricia`}</TableCell>
                                <TableCell>{`Harris`}</TableCell>
                                <TableCell>{`patricia_harris@example.com`}</TableCell>
                                <TableCell>{`student`}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
        </StyledDialog>
    );
};

export default RosterModal;
